// Growing Circle shell — mounted under <Route path="/growing-circle/*"> in the
// canonical App.js. Provides Circle-scoped providers (Auth, Sonner Toaster)
// and applies the .gc-shell wrapper class so that ALL Circle-specific CSS
// (see ./styles.css) is scoped to this subtree and CANNOT visually affect the
// canonical public website.
//
// Deliberate scoping decisions (per the integration brief):
//   - AuthProvider   : Circle-only, mounted here (not globally)
//   - Toaster (sonner): Circle-only, mounted here (not globally). If the
//     public site later needs its own toast surface it should mount its own.
//   - QueryClientProvider: NOT mounted here — canonical /app/frontend/src/index.js
//     already provides one globally, and useQuery/useMutation from
//     @tanstack/react-query in Circle pages consumes it. Re-providing it here
//     would create two clients with no shared cache. Left as-is.

import "@/modules/growing-circle/styles.css";
import { AuthProvider } from "@/modules/growing-circle/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import GrowingCircleRouter from "@/modules/growing-circle/Router";

export default function GrowingCircleShell() {
  return (
    <div className="gc-shell" data-testid="growing-circle-shell">
      <AuthProvider>
        <GrowingCircleRouter />
        <Toaster position="top-center" />
      </AuthProvider>
    </div>
  );
}
